import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "iconColor", "icon", "selected", "size", "opacity", "onClick", "borderColor", "borderWidth"];
import unescapedText from 'I18n/utils/unescapedText';
import { Button } from '../Button/Button';
import { FieldsetContextConsumer } from '../../context/FieldsetContext';
import { rgba } from '../../utils/color';
import { callIfPossible } from '../../utils/functions';
import { syntheticEvent } from '../../utils/SyntheticEvent';
import { IconCircle } from '../IconCircle/IconCircle';
import { uniqueId } from '../../utils/uniqueId';
import { SuccessIcon } from 'foundations-assets';
import { ColorSwatchProvider } from './ColorSwatchProvider';
import { useTheme } from 'foundations-theming/utils';
import { ScreenReaderOnly } from '../ScreenReaderOnly';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SIZES = {
  small: 16,
  default: 20
};
export const ColorSwatch = _ref => {
  var _theme$color;
  let {
      color,
      iconColor = 'text-core-on-fill-default',
      icon: Icon = SuccessIcon,
      selected = false,
      size,
      opacity,
      onClick,
      borderColor,
      borderWidth = '0'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const id = uniqueId('color-input');
  const theme = useTheme();
  const colorValue = (_theme$color = theme.color[color]) !== null && _theme$color !== void 0 ? _theme$color : color;
  const handleClick = () => {
    callIfPossible(onClick, syntheticEvent(colorValue));
  };
  const hasOpacity = opacity != null;
  const backgroundColor = hasOpacity && colorValue != null ? rgba(colorValue, opacity / 100) : colorValue;
  const computedColor = selected ? iconColor : 'fill-transparent-default';
  const describedById = `${id}-desc`;
  return /*#__PURE__*/_jsx(FieldsetContextConsumer, {
    children: fieldsetContext => {
      const computedSize = size != null ? size : SIZES[fieldsetContext.size];
      return /*#__PURE__*/_jsx(ColorSwatchProvider, {
        buttonStyleOverrides: Object.assign({
          blockSize: computedSize * 2,
          inlineSize: computedSize * 2
        }, hasOpacity ? {
          backgroundImage: `url('${require('bender-url!ui-images/optimized/transparent_background.svg')}')`
        } : undefined),
        iconCircleStyleOverrides: {
          backgroundColor,
          fontSize: computedSize
        },
        children: /*#__PURE__*/_jsxs(Button, {
          use: "unstyled",
          "aria-describedby": describedById,
          onClick: handleClick,
          children: [/*#__PURE__*/_jsx(ScreenReaderOnly, {
            id: describedById,
            children: colorValue ? unescapedText('ui.UIColorSwatch.label', {
              value: colorValue
            }) : unescapedText('ui.UIColorSwatch.noColorLabel')
          }), /*#__PURE__*/_jsx(IconCircle, Object.assign({}, rest, {
            borderColor: borderColor,
            borderWidth: borderWidth,
            color: computedColor,
            margin: "0 !important",
            legacy: true,
            "data-test-id": "trellis-color-swatch",
            icon: Icon,
            size: "inherit" // Size is set by `fontSize` in `iconCircleStyleOverrides`
          })), /*#__PURE__*/_jsx(ScreenReaderOnly, {
            id: describedById,
            children: colorValue ? unescapedText('ui.UIColorSwatch.label', {
              value: colorValue
            }) : unescapedText('ui.UIColorSwatch.noColorLabel')
          })]
        })
      });
    }
  });
};